import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { RootState as RootStateV2, AppDispatch as AppDispatchV2 } from '../storeV2';

/** Typed version of plain `useDispatch` */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const useAppDispatchV2 = () => useDispatch<AppDispatchV2>();

/** Typed version of plain `useSelector` */
export const useAppSelectorV2: TypedUseSelectorHook<RootStateV2> = useSelector;
